import * as React from 'react';


function HistoricalFinancialsTable({financialReport, metricsDictionary, numberOfYears} :any) {

  function HistoricalFinancialsTableRow({financialReport, metric} :any) {

    function displayableRow(financialReport, metric) : Boolean {

      const everyMetricIsNull = financialReport.every(item => ((columnValue(item, metric) == null) &&  (columnValue(item, metric) == undefined)))
      return (everyMetricIsNull ? false : true)
    }

    function columnValue(report, metric) {
      return (metric.useHumanValue ? report[metric.columnName]?.human_value : report[metric.columnName])
    }
    if (displayableRow(financialReport, metric)) {
      return (
        <tr>
          <td width="10%" className="table-dark"><strong>{metric.displayName}</strong></td>
          {financialReport?.map((item =>
            <td className={ item[metric.className] }>{columnValue(item, metric)}</td>
          ))}
        </tr>
      )
    } else {
      return(<span/>)
    }
  }

  function years() : Array<Number>  {
    return financialReport.map((report => report.year))
  }

  return (
    <table className="table table-hover table-bordered table-sm">
      <thead>
        <tr>
          <th className="table-dark"><strong></strong></th>
          {years().map((year =>
            <th className="table-dark"><strong>{year}</strong></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {metricsDictionary.map((metric =>
          <HistoricalFinancialsTableRow
            financialReport={financialReport}
            metric={metric}
          />
        ))}
      </tbody>
    </table>
  );
}

export default HistoricalFinancialsTable;
